export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_32-e310378ef96a091f9aaead750123865f.jpg";